import { SkillsManagerCanvas } from '@/components/profile/skills-manager-canvas'

/** Passthrough to SkillsManagerCanvas — that module owns the root ArtifactCanvasBody; do not wrap again. */

interface UnifiedSkillsCanvasProps {
  onClose: () => void
  /** When true, focus the add-skill field on open (empty profile flow). */
  focusAdd?: boolean
}

export function UnifiedSkillsCanvas({ onClose, focusAdd = false }: UnifiedSkillsCanvasProps) {
  return <SkillsManagerCanvas onClose={onClose} focusAdd={focusAdd} />
}
